<div class="container bg-whitesmoke py-4">
  <app-breadcrumb [activePanel]="'about'"></app-breadcrumb>
  
  <div class="about-page" *ngIf="card; else noCard">

    <!-- Action Buttons -->
    <div class="d-flex justify-content-end gap-2 mb-3">
      <button mat-icon-button color="primary" (click)="goToEditPage()" matTooltip="Edit Card">
        <mat-icon>edit</mat-icon>
      </button>
      <button mat-icon-button color="accent" (click)="downloadCard()" matTooltip="Download Card">
        <mat-icon>download</mat-icon>
      </button>
    </div>

<!-- Business Section -->
<section class="about-section business-section mb-4 p-3 bg-white rounded shadow-sm" *ngIf="card.business_info">
  <h2 class="section-title">
    <i class="bi bi-building me-2"></i> About Information
  </h2>
  <ul class="info-list list-unstyled">
    <li *ngIf="card.industry"><strong>Industry:</strong> {{ card.industry }}</li>
    <li *ngIf="card.type"><strong>Type:</strong> {{ card.type }}</li>
    <li *ngIf="card.handler" class="d-flex align-items-center flex-wrap gap-2">
  <div>
    <strong>Handler:</strong>
    <a [href]="environment.appUrl + '/' + card.handler" target="_blank" class="text-primary text-decoration-none">
      {{ card.handler }}
    </a>
  </div>

  <!-- Action Icons -->
  <div class="ms-2 d-flex align-items-center gap-2">
    <button mat-icon-button color="primary" (click)="copyHandlerLink()" title="Copy link">
      <mat-icon>content_copy</mat-icon>
    </button>
    <button mat-icon-button color="accent" (click)="shareHandlerLink()" title="Share link">
      <mat-icon>share</mat-icon>
    </button>
  </div>
</li>


    <li *ngIf="card.business_info?.companyAddress"><strong>Address:</strong> {{ card.business_info.companyAddress }}</li>
    <li *ngIf="card.business_info?.companyEmail"><strong>Email:</strong> {{ card.business_info.companyEmail }}</li>
    <li *ngIf="card.business_info?.companyPhone"><strong>Phone:</strong> {{ card.business_info.companyPhone }}</li>
    <li *ngIf="card.business_info?.companyWebsite">
      <strong>Website:</strong>
      <a [href]="'https://' + card.business_info.companyWebsite" target="_blank">
        {{ card.business_info.companyWebsite }}
      </a>
    </li>
    <li *ngIf="card.business_info?.description"><strong>Description:</strong> {{ card.business_info.description }}</li>
  </ul>
</section>


  <!-- Contact Section -->
  <section class="about-section contact-section mb-4 p-3 bg-white rounded shadow-sm" *ngIf="card.contact_info">
    <h2 class="section-title">
      <i class="bi bi-person me-2"></i> Contact Information
    </h2>
    <ul class="info-list list-unstyled">
      <li *ngIf="card.contact_info?.contactName"><strong>Name:</strong> {{ card.contact_info.contactName }}</li>
      <li *ngIf="card.contact_info?.jobTitle"><strong>Job Title:</strong> {{ card.contact_info.jobTitle }}</li>
      <li *ngIf="card.contact_info?.department"><strong>Department:</strong> {{ card.contact_info.department }}</li>
      <li *ngIf="card.contact_info?.primaryEmail"><strong>Email:</strong> {{ card.contact_info.primaryEmail }}</li>
      <li *ngIf="card.contact_info?.primaryPhone"><strong>Phone:</strong> {{ card.contact_info.primaryPhone }}</li>
      <li *ngIf="card.contact_info?.whatsappNumber"><strong>WhatsApp:</strong> {{ card.contact_info.whatsappNumber }}</li>
    </ul>
  </section>

 <!-- QR Code Section -->
<section class="about-section share-qr-section mb-4 p-3 bg-white rounded shadow-sm text-center" *ngIf="card?.handler">
  <h2 class="section-title">
    <i class="bi bi-qr-code me-2"></i> Share vCard
  </h2>

  <div class="d-flex flex-column align-items-center">
    <!-- Spinner -->
    <div *ngIf="qrLoading" class="d-flex justify-content-center my-3">
      <mat-spinner diameter="50"></mat-spinner>
    </div>

    <!-- QR Canvas always in DOM -->
    <canvas #qrCanvas class="mb-2"></canvas>

    <!-- Handler URL -->
    <p class="mb-2"><small>{{ environment.appUrl }}/{{ card.handler }}</small></p>

    <!-- Copy & Share -->
    <div class="d-flex justify-content-center gap-2 mb-3">
      <button mat-icon-button color="primary" (click)="copyHandlerLink()" title="Copy link">
        <mat-icon>content_copy</mat-icon>
      </button>
      <button mat-icon-button color="accent" (click)="shareHandlerLink()" title="Share link">
        <mat-icon>share</mat-icon>
      </button>
    </div>

    <!-- Contact Info -->
    <ul class="info-list list-unstyled text-center" *ngIf="card.contact_info">
      <li class="d-flex justify-content-center gap-3 mb-1" *ngIf="card.contact_info?.contactName || card.contact_info?.primaryPhone">
        <span *ngIf="card.contact_info?.contactName"><strong>Name:</strong> {{ card.contact_info.contactName }}</span>
        <span *ngIf="card.contact_info?.primaryPhone"><strong>Phone:</strong> {{ formatPhone(card.contact_info.primaryPhone) }}</span>
      </li>
      <li *ngIf="card.contact_info?.primaryEmail">
        <strong>Email:</strong> {{ card.contact_info.primaryEmail }}
      </li>
    </ul>
  </div>
</section>




  <!-- Social Links -->
  <section class="about-section social-links-section mb-4 p-3 bg-white rounded shadow-sm" *ngIf="socialLinkArray.length > 0">
    <h2 class="section-title">
      <i class="bi bi-share me-2"></i> Social Links
    </h2>
    <ul class="list-inline mb-0">
      <li class="list-inline-item" *ngFor="let s of socialLinkArray">
        <a [href]="s.url" target="_blank">{{ s.platform }}</a>
      </li>
    </ul>
  </section>

  <!-- Quick Links -->
  <section class="about-section quick-links-section mb-4 p-3 bg-white rounded shadow-sm" *ngIf="quickLinkArray.length">
    <h2 class="section-title">
      <i class="bi bi-link-45deg me-2"></i> Quick Links
    </h2>
    <ul class="list-inline mb-0">
      <li class="list-inline-item" *ngFor="let q of quickLinkArray">
        <a [href]="q.url" target="_blank">{{ q.title }}</a>
      </li>
    </ul>
  </section>

  </div>

  <ng-template #noCard>
    <div class="no-card text-center py-5">
      <mat-icon color="accent" class="mb-2" style="font-size:48px;">info</mat-icon>
      <p>No card available</p>
    </div>
  </ng-template>
</div>